import { render, staticRenderFns } from "./ElementStudioDropdownOptions.vue?vue&type=template&id=4bf88290&"
import script from "./ElementStudioDropdownOptions.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioDropdownOptions.vue?vue&type=script&lang=ts&"
import style0 from "./ElementStudioDropdownOptions.vue?vue&type=style&index=0&id=4bf88290&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports